module.exports = __webpack_public_path__ + "static/media/ShieldedBadge.1bfac5da.svg";